import React ,{useEffect, useState}from "react";
import NavBar from "../NavBar";
import CardRender from "../DashboardCardRender";
import IDCard  from "./IDcard/CustomerIDcard";
import "./crm.css"
import WideCard from "../WideCard";
const CRMCustomers = ()=>{
  const [count,setCount]=useState([]);
  const [filtr, setFiltr] = useState("");
  const [type, setType] = useState("all");
  const handle1 = () => {
    setType("all");
  };
  const handle2 = () => {
    setType("open");
  };
  const handle3 = () => {
    setType("past");
  };
  useEffect(() => {
    if (type === "open") {
      setCount(
        IncomingData.filter(
          (x) => x.td4 === "Unpaid" || x.td4 === "Overdue"
        )
      );
    } else if (type === "past") {
      setCount(IncomingData.filter((x) => x.td4 === "Paid"));
    } else {
      setCount("");
    }
    setFiltr("");
  }, [type]);

  const handleFilter = (e) => {
    setFiltr(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.Budget < 5000
      } 
      else if (e.target.value === '2') {
        return x.Budget > 50000
      }
      else if (e.target.value === '3') {
        return x.Budget > 100000
      }
    }));
  };
// x.Budget === e.target.value
    return(
        <>
        <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Customer Relationship Management   </span>
          <span className="color"> &#62; </span>
          <span className="color"> Customers</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h1>Customers</h1>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="click-data" style={{ marginLeft:"1.5rem"}}>
            <p>Active</p>
            <p>Completed</p>
        </div>
        <div id="OMS-main-content">

<div className="order-list-box" style={{ width: "64%",marginLeft:'1.5rem',marginTop:'0' }}>
  
  <div className="order-list-input-box" style={{width:"auto"}}>
    <div className="order-list-input-left">
      <input type="text" 
        placeholder="Search for campaign name, employee name"
        onChange={(val) => {
          setCount(
            IncomingData.filter((x) =>
              x.Order_id.match(val.target.value) || x.Customer_name.match(val.target.value)
            )
          );
          setFiltr("");
          setType("all");
        }
        }
      />
      {/* <img src={searchWhiteIcon} alt="" width="" /> */}
    </div>
    <div className="order-list-input-right"  style={{width:"none"}}>
      <select name="" id="" className="order-list-input-right-filters"
      value={filtr}
      onChange={handleFilter}
      >
        <option value="" selected>
          by amount
        </option>
        <option value="1">&lt;5000</option>
        <option value="2">&gt;50000</option>
        <option value="3">&gt;100000</option>
      </select>
      
    </div>
  </div>
  <table  className="th-light" style={{ textAlign: "center"}}>
    <tr>
      <th>Order ID</th>
      <th>Customer Name</th>
      <th>Order</th>
      <th>Bill Amount</th>
      <th>Ordered on</th>
      <th>Category Veiwed</th>
      <th>Last order</th>
    </tr>
  {count.length>0 ? count.map((val)=>{
    return (
        <tr>
          <td style={{textDecoration:"underline"}}>{val.Order_id}</td>
          <td>{val.Customer_name}</td>
          <td>{val.Department_name}</td>
          <td>{val.Budget}</td>
          <td>{val.Started_on}</td>
          <td>{val.Goals}</td>
          <td>{val.Duration}</td>
        
        </tr>
      );
  })
     : IncomingData.map((val) => {
      return (
        <tr >
          <td  style={{textDecoration:"underline"}}>{val.Order_id}</td>
          <td>{val.Customer_name}</td>
          <td>{val.Department_name}</td>
          <td>{val.Budget}</td>
          <td>{val.Started_on}</td>
          <td>{val.Goals}</td>
          <td>{val.Duration}</td>
        
        </tr>
      );
    })}
  </table>
</div>

{/* card data */}
<div>
  
  <div style={{display:'flex',gap:"1rem",width:"30rem"}}>
      <CardRender comp={CRMCustomerData}/>
  </div>
  
    <WideCard  data={CRMCustomerWideCardData} />
      <IDCard/>
  </div>
  
</div>
        
        </>
    );
}
const  CRMCustomerData = [ {
  card1up1: "1200",
  card1up2: "customers",
  card1up3: "increased by 5% since last month",
  card1dnP: "TOTAL CUSTOMERS",
},
{
  card1up1: "10",
  card1up2: "subscribed",
  card1up3: "increased by 10% since last month",
  card1dnP: "SUBSCRIBERS",
}
];
const CRMCustomerWideCardData = {
  card1up1: "1500",
  card1up3: 'increased by 10% since last year',
  card1dnP: "TARGET FOR THIS YEAR",
}

export default CRMCustomers;

const IncomingData = [
  {
      Order_id : "XASDADSA56",
      Customer_name: "Donald Trump" ,
      Department_name: "Development",
      Budget : 1590,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 120000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },{
      Order_id : "XASDADSA98",
      Customer_name: "Joe Dee" ,
      Department_name: "Development",
      Budget : 12000,
      Started_on : "28/06/2022",
      Goals : "Shoes",
      Duration :"18 months"
  },
]